import { Component, Input } from '@angular/core';

import { PaymentOptionComponent } from '../../payment-option.component';

/**
 * "the_portrait" view of /payment-option.
 *
 * No mockup exists for this screen — it is derived from the theme's other surfaces. It sits
 * between /payment-price CONFIRM and the QR pages, and is also where "MORE PAYMENT OPTION"
 * leads, so leaving it on the default theme would break the journey visually twice.
 */
@Component({
  selector: 'app-payment-option-portrait',
  templateUrl: './payment-option-portrait.component.html',
  styleUrls: ['./payment-option-portrait.component.scss']
})
export class PaymentOptionPortraitComponent {

  @Input() host!: PaymentOptionComponent;

}
